import React from 'react';
import { FactoryIcon, ClipboardCheckIcon, LayersIcon, BarChart3Icon, PackageIcon, WrenchIcon, TruckIcon, ShieldCheckIcon, UsersIcon, CalendarIcon, ZapIcon, RepeatIcon } from 'lucide-react';
import { SolutionPageLayout } from '../../components/SolutionPageLayout';
const features = [{
  icon: LayersIcon,
  title: 'Multi-Level BOM Management',
  description: 'Manage complex, multi-level bills of materials with revision control, effectivity dates, and engineering change orders. Support make-to-order, make-to-stock, and configure-to-order.'
}, {
  icon: CalendarIcon,
  title: 'Production Planning & Scheduling',
  description: 'Plan and schedule production across work centers with finite capacity constraints. Balance load, minimize changeovers, and meet delivery commitments.'
}, {
  icon: FactoryIcon,
  title: 'Shop Floor Execution',
  description: 'Track work orders through every operation in real time. Capture labor, material consumption, and output with barcode scanning and touchscreen terminals.'
}, {
  icon: ClipboardCheckIcon,
  title: 'Quality & Compliance',
  description: 'Built-in quality management with inspection plans, NCR tracking, CAPA workflows, and SPC. Maintain compliance with ISO, AS9100, IATF, and customer-specific requirements.'
}, {
  icon: PackageIcon,
  title: 'Inventory & Material Control',
  description: 'Real-time inventory visibility with lot traceability, cycle counting, and automated reorder points. Know what you have, where it is, and when to buy more.'
}, {
  icon: WrenchIcon,
  title: 'Tooling & Maintenance',
  description: 'Track tool life, schedule preventive maintenance, and manage spare parts inventory. Reduce unplanned downtime and extend equipment life.'
}, {
  icon: TruckIcon,
  title: 'Supply Chain Coordination',
  description: 'Manage vendors, purchase orders, and inbound logistics. Track supplier performance and ensure materials arrive when production needs them.'
}, {
  icon: BarChart3Icon,
  title: 'OEE & Performance Analytics',
  description: 'Monitor Overall Equipment Effectiveness, throughput, yield, and scrap in real time. Identify bottlenecks and drive continuous improvement with data.'
}, {
  icon: ShieldCheckIcon,
  title: 'Traceability & Recall Readiness',
  description: 'Full forward and backward traceability from raw material to finished product. Be audit-ready and recall-capable at all times.'
}, {
  icon: UsersIcon,
  title: 'Labor & Workforce Management',
  description: 'Track direct labor by work order and operation. Manage certifications, training records, and crew assignments across shifts.'
}, {
  icon: ZapIcon,
  title: 'Machine & IoT Integration',
  description: 'Connect to CNC machines, PLCs, and sensors for automated data collection. Eliminate manual data entry and get real-time process visibility.'
}, {
  icon: RepeatIcon,
  title: 'Continuous Improvement',
  description: 'Built-in tools for tracking improvement initiatives, measuring results, and sustaining gains. Support lean, Six Sigma, and kaizen methodologies.'
}];
export function ManufacturingPage() {
  return <SolutionPageLayout label="Manufacturing" title="ERP built for how manufacturing actually works" subtitle="From job shops to high-volume production, Thruline gives manufacturing teams the tools to plan, execute, and improve — without fighting their software." features={features} data-id="element-406" />;
}